import {  } from '../functions.js';

/*
Usage:
<calculation-element scope="this"> // Or scope="document"

    <input type="number" name="weekly_km_urban" class="form__input" placeholder="Ej.: 20" min="0" value="">
    <input type="number" name="weekly_km_highway" class="form__input" placeholder="Ej.: 30" min="0" value="">

    <p>
        En total haces <strong data-formula="input[name=weekly_km_urban]+input[name=weekly_km_highway]">--</strong> <strong>km</strong> a la semana aprox. juntando ciudad y carretera
    </p>

    <input type="number" name="yearly_km_highway" class="form__input" placeholder="Ej.: 80000" min="0" value="">

    <p>
        Haces aproximadamente unos <strong data-formula="input[name=yearly_km_highway]-(input[name=weekly_km_urban]+input[name=weekly_km_highway])">--</strong> <strong>km</strong> en viajes largos anualmente
    </p>

</calculation-element>

Limitation: operador selector should abide by the regex defined in OPERAND_SELECTOR_REGEX  
*/

const OPERAND_SELECTOR_REGEX = /([a-zA-Z_][\w\[\]=]+)/g;

export default class CalculationElement extends HTMLElement {

    connectedCallback() {
        this.#bindEvents();
        this.#calculate();
    }

    #bindEvents() {
        let scope = this.#getScope();
        this.querySelectorAll('[data-formula]').forEach(elm => {
            let formula = elm.dataset.formula;
            let operands = this.#extractOperands(formula);
            
            operands.forEach(operandSelector => {
                let input = scope.querySelector(operandSelector.trim());

                if (!input) {
                    console.error(`Input ${operandSelector} not found`);
                    return;
                }

                input.addEventListener('input', this.#calculate.bind(this));
            });
        });
    }

    #getScope() {
        return this.getAttribute('scope') === 'document' ? document : this;
    }

    #calculate() {
        let scope = this.#getScope();
        

        this.querySelectorAll('[data-formula]').forEach(elm => {

            let formula = elm.dataset.formula;

            let operands = this.#extractOperands(formula);

            operands.forEach(selector => {
                const element = scope.querySelector(selector);
                const value = parseInt(element.value) || parseInt(element.textContent) || 0;

                formula = formula.replace(selector, value);
            });

            formula = 'return ' + formula;

            // https://esbuild.github.io/content-types/#direct-eval
            let result = ((new Function(formula)).bind(this))();
            elm.innerText = result;
    
        });

    }

    #extractOperands(expression) {
        let operands = [...expression.matchAll(OPERAND_SELECTOR_REGEX)]
        return operands.map(operand => {
            return operand[1];
        });
    }

}

customElements.define('calculation-element', CalculationElement);
